export default {
  privat: {
    breadcrumbHome: 'Inicio',
    breadcrumbSolutions: 'Soluciones',
    breadcrumbCurrent: 'Hogar y terreno',
    hero: {
      eyebrow: 'Clientes particulares',
      title: 'Su hogar a la vista: bien planificado e instalado con discreción',
      lead: 'Casa unifamiliar, piso o edificio de viviendas: protegemos su privacidad y su propiedad con sistemas de cámaras a medida. Sin alarmismo, sin vigilancia excesiva.',
    },
    useCases: {
      title: 'Soluciones para su hogar',
      lead: 'Cada casa es diferente. Estudiamos sus accesos, condiciones de luz y deseos, y planificamos los puntos de vigilancia adecuados.',
      items: {
        '0': { title: 'Puerta y entrada', desc: 'La puerta de entrada es el punto de vigilancia más importante. Planificamos una cámara discreta con buena resolución, para reconocimiento facial y paquetes.' },
        '1': { title: 'Entrada y garaje', desc: 'Reconocimiento de matrículas, vigilancia de vehículos y control de accesos con cámaras exteriores resistentes y visión nocturna.' },
        '2': { title: 'Jardín y terraza', desc: 'Vigile accesos al jardín, terrazas y entradas secundarias. Cámaras resistentes con gran angular para la visión general.' },
        '3': { title: 'Entradas secundarias y sótano', desc: 'A menudo olvidados, pero un punto de acceso habitual. Cámaras adicionales cierran la última brecha.' },
        '4': { title: 'Edificios de viviendas', desc: 'Entrada, escalera y exteriores: planificados con respeto a la privacidad, con enmascaramiento y señalización.' },
        '5': { title: 'Acceso desde el móvil', desc: 'Vista en vivo y reproducción en su teléfono, esté en casa o fuera. Lo configuramos todo.' },
      },
    },
    night: {
      eyebrow: 'Visión nocturna',
      title: 'Seguridad que no duerme',
      lead: 'La mayoría de incidentes ocurren en la oscuridad. Con cámaras especiales día/noche mantiene la visión general también de noche, en blanco y negro con infrarrojos o en color.',
      items: {
        '0': { title: 'Visión nocturna infrarroja', desc: 'Imágenes nítidas incluso en completa oscuridad, hasta 30 m de alcance según el modelo.' },
        '1': { title: 'Color nocturno', desc: 'Imágenes en color por la noche en vez de blanco y negro, gracias a sensores Starlight muy sensibles.' },
        '2': { title: 'Iluminación inteligente', desc: 'LED de luz blanca ante movimiento, como disuasión y para grabaciones en color.' },
      },
    },
    privacy: {
      eyebrow: 'Protección de datos',
      title: 'Proteger zonas privadas, respetar los derechos',
      lead: 'En la videovigilancia privada, la protección de datos es especialmente importante. Desde el principio cuidamos:',
      list: {
        '0': 'No captar vías públicas ni terrenos vecinos',
        '1': 'Enmascaramiento de zonas privadas en la cámara o el grabador',
        '2': 'Señalización en las entradas (recomendado legalmente)',
        '3': 'Almacenamiento local: sus datos se quedan con usted',
        '4': 'Derechos de acceso y gestión de usuarios para edificios',
      },
      note: 'Nota: la legalidad de la videovigilancia depende del caso concreto. Le asesoramos, pero no sustituimos el asesoramiento jurídico.',
    },
    cta: {
      title: 'Proteja lo que le importa',
      lead: 'Una primera conversación sin compromiso le muestra las posibilidades para su hogar, con transparencia y sin presión.',
      primary: 'Concertar una cita de asesoría',
      secondary: 'Iniciar el planificador de cámaras',
    },
  },
};